
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationReturnLaborDialog extends Common.GridEditorDialog<CertificationReturnLaborRow> {
        protected getFormKey() { return CertificationReturnLaborForm.formKey; }
        //protected getIdProperty() { return CertificationReturnLaborRow.idProperty; }
        protected getLocalTextPrefix() { return CertificationReturnLaborRow.localTextPrefix; }
        //protected getNameProperty() { return CertificationReturnLaborRow.nameProperty; }
        //protected getService() { return CertificationReturnLaborService.baseUrl; }
        protected getDeletePermission() { return CertificationReturnLaborRow.deletePermission; }
        protected getInsertPermission() { return CertificationReturnLaborRow.insertPermission; }
        protected getUpdatePermission() { return CertificationReturnLaborRow.updatePermission; }

        protected form = new CertificationReturnLaborForm(this.idPrefix);

    }
}